<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0003 21C16.8605 21 20.8004 16.9706 20.8004 12C20.8004 7.02944 16.8605 3 12.0003 3C7.14005 3 3.20007 7.02944 3.20007 12C3.20007 16.9706 7.14005 21 12.0003 21Z"
      class="stroke-current"
      stroke-width="1.5"
    />
  </svg>
</template>
